import { hotjar } from 'react-hotjar';
import { generateUserProperties } from '../user_properties';
import enviroment from '../../enviroment';

const { HOTJAR_ID } = enviroment;

export const hotJarinitialize = () => {
  hotjar.initialize(HOTJAR_ID);
};

export const hotJarIdentifyUser = (userId) => {
  const attributes = generateUserProperties();
  hotjar.identify(`${ userId }`, { ...attributes });
};

export const hotJarReset = () => {
  hotjar.identify(null);
};
